export default "__VITE_ASSET__DJIrb1uq__"